/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable check-file/filename-naming-convention */
import * as React from 'react';
import type { SVGProps } from 'react';

export type IllustrationSizeVariants =
  | 'small'
  | 'medium'
  | 'large'
  | 'xlarge'
  | 'xxlarge'
  | 'xxxlarge'
  | 'xxxxlarge';
export type IllustrationProps = {
  width?: number | string;
  height?: number | string;
  size?: IllustrationSizeVariants;
};
const IllustrationStickerRockHand = ({
  size = 'medium',
  width,
  height,
  ...props
}: IllustrationProps) => {
  let presetWidth: string | undefined;
  let presetHeight: string | undefined;
  const presets = {
    small: '48px',
    medium: '68px',
    large: '92px',
    xlarge: '122px',
    xxlarge: '156px',
    xxxlarge: '194px',
    xxxxlarge: '236px',
  };
  if (size) {
    presetWidth = presets[size];
    presetHeight = presets[size];
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 68 68"
      width={width || presetWidth}
      height={height || presetHeight}
      data-xds="IllustrationStickerRockHand"
      {...props}
    >
      <path
        fill="var(--xdlColorIllustrationBackground)"
        d="m60.46 45.896-7.673-5.678 13.91-5.062-12.988-7.725 8.968-16.003-15.383 6.048-5.459-15.02-6.513 12.833-12.16-11.205a4.6 4.6 0 0 0-6.347.162 4.614 4.614 0 0 0-.147 6.366l6.123 6.637a5.208 5.208 0 0 0-2.5 3.8 5.2 5.2 0 0 0-3.884 2.645L9.72 17.525a4.6 4.6 0 0 0-3.086-1.186c-1.232 0-2.388.48-3.26 1.352a4.61 4.61 0 0 0-.152 6.358l8.202 8.942-10.12 2.728 15.704 7.215-8.599 17.197 17.306-9.482 4.802 16.637 6.637-11.806 7.79 10.525 3.344-2.47-7.964-10.763 14.847 6.72-3.083-11.677 9.95 7.363 2.475-3.34-5.463-4.041z"
      />
      <path
        fill="#fff"
        d="M48.03 25.266a10.12 10.12 0 0 0-5.541-5.225l-1.179-.457-3.34-1.175a6.15 6.15 0 0 0-3.097-.393l-.004.004-.004-.004c-.034.004-.064.012-.098.015l-.707-.245q.223-.058.45-.099L21.571 5.762a2.345 2.345 0 0 0-3.226.083 2.34 2.34 0 0 0-.083 3.226l9.255 10.034.065.057-.288.26-.03-.034a2.98 2.98 0 0 0-1.836-.63c-.8 0-1.552.31-2.12.876a3 3 0 0 0-.396 3.748l-.385.347a3 3 0 0 0-1.606-.468c-.8 0-1.552.31-2.119.876a3.01 3.01 0 0 0-.56 3.46l-.513.465-9.6-8.859a2.342 2.342 0 0 0-3.306 3.31L20.65 39.765l3.193 3.555a12.38 12.38 0 0 0 8.96 4.14c3.457.09 6.721-1.205 9.17-3.657l3.335-3.335c3.978-3.979 5.073-10.087 2.724-15.202"
      />
      <path
        fill="#A456F6"
        d="M15.255 34.09 7.31 36.237l12.44 5.716-6.584 13.17 13.75-7.537 4.145 14.37 6.996-12.443 13.91 6.297-4.22-15.987L61.79 34.71l-10.963-6.52 7.11-12.69-11.945 4.696L41.442 7.68l-5.145 10.136s5.293 1.572 6.479 2.157c1.186.586 5.258 2.059 6.615 9.698 1.356 7.638-6.657 13.822-7.733 14.703-.79.642-5.316 4.306-10.907 3.071-2.047-.453-4.545-1.224-6.615-3.517z"
      />
      <path
        fill="#1D2124"
        fillRule="evenodd"
        d="m21.82 5.497 13.157 12.125a6.5 6.5 0 0 1 1.183-.016l.034.003 5.279-10.405 4.631 12.747 12.259-4.821-7.28 12.992 11.148 6.63-14.257 5.187 4.277 16.206-14.114-6.392-7.133 12.69-4.208-14.575-14.072 7.715 6.77-13.54L6.758 36.19l8.076-2.181L4.537 22.78a2.72 2.72 0 0 1 .095-3.748 2.72 2.72 0 0 1 3.747-.094l9.48 8.74a3.38 3.38 0 0 1 .678-3.799 3.38 3.38 0 0 1 3.845-.656 3.35 3.35 0 0 1-.331-1.46c0-.899.351-1.749.99-2.383a3.38 3.38 0 0 1 3.45-.815l-8.513-9.226a2.72 2.72 0 0 1 .095-3.748 2.72 2.72 0 0 1 3.747-.094m5.428 13.888 2.267 2.456-2.362 5.886-1.689-1.689.002-.002-2.157-2.157-.065-.063a2.97 2.97 0 0 1-.812-2.052c0-.801.31-1.553.877-2.12a3 3 0 0 1 3.94-.259m5.83-1.267a6.5 6.5 0 0 0-3.334 3.19l-1.932-1.928a3 3 0 0 0-.303-.269l-9.251-10.03a2.34 2.34 0 0 1 .083-3.225c.884-.88 2.3-.918 3.226-.083l12.926 11.919c-.48.088-.955.23-1.415.426m5.021-.056a6.6 6.6 0 0 0-1.506-.408l4.823-9.502 4.465 12.293 11.636-4.574-6.944 12.387 10.782 6.41-13.834 5.033 4.163 15.772-13.706-6.207-6.86 12.202-4.088-14.155-13.426 7.355 6.4-12.803-12.142-5.58 7.262-1.96 5.235 5.708 3.192 3.555a12.76 12.76 0 0 0 9.592 4.269c3.434 0 6.648-1.334 9.089-3.778l3.336-3.336c4.091-4.091 5.217-10.374 2.799-15.628a10.5 10.5 0 0 0-5.75-5.418l-1.182-.46zm-.14.358a6.2 6.2 0 0 0-3.08-.4l-.014.015-.013-.012a6.2 6.2 0 0 0-1.63.447 6.14 6.14 0 0 0-3.306 3.38l-3.502 8.731a6.186 6.186 0 0 0 7.858-3.502l.661-1.647c.163-.404.472-.71.88-.869.405-.159.843-.14 1.236.045l2.206 1.058-.162.34-2.207-1.058a1.16 1.16 0 0 0-.937-.034c-.306.121-.544.352-.664.658l-.363.903 2.788 2.788a3.35 3.35 0 0 1 .99 2.383c0 .9-.352 1.75-.99 2.384a3.38 3.38 0 0 1-2.392.998c-.509 0-1.002-.113-1.45-.327.215.448.328.942.328 1.452 0 .9-.351 1.75-.99 2.384a3.38 3.38 0 0 1-2.39.993c-.9 0-1.75-.35-2.385-.99l-7.718-7.714-12.59-11.612a2.345 2.345 0 0 0-3.227.083 2.34 2.34 0 0 0-.083 3.226l15.825 17.253 3.192 3.555a12.38 12.38 0 0 0 8.961 4.14 12.37 12.37 0 0 0 9.169-3.656l3.336-3.336c3.978-3.978 5.073-10.09 2.723-15.202a10.12 10.12 0 0 0-5.542-5.225l-1.178-.457zm-3.336 8.799.145-.361 2.673 2.673c.567.567.877 1.318.877 2.12 0 .8-.31 1.552-.876 2.119a2.97 2.97 0 0 1-2.12.876 2.97 2.97 0 0 1-2.05-.81l-.066-.067-2.73-2.73a6.55 6.55 0 0 0 4.147-3.82m-1.616 6.89-.072-.071-2.883-2.883a6.5 6.5 0 0 1-3.955-.29l-.174-.072 1.078-2.686-3.96-3.96a3 3 0 0 0-4.235 0 3 3 0 0 0 0 4.235l2.155 2.156.436.402-.016.018 7.319 7.318a2.97 2.97 0 0 0 2.119.877c.8 0 1.553-.31 2.12-.877a2.97 2.97 0 0 0 .876-2.12c0-.767-.285-1.49-.808-2.048"
        clipRule="evenodd"
      />
      <path
        fill="#1D2124"
        d="m51.437 41.637-.225.303 6.301 4.664.225-.304zM52.047 45.506l.224-.304 9.52 7.046-.225.303zM39.297 55.31l.303-.225 5.967 8.062-.304.225z"
      />
    </svg>
  );
};
export default IllustrationStickerRockHand;
